import * as service from './service'
export default {
  namespace: 'recruitSureReceiving',
  state: {
    receiveData: {}
  },
  effects: {
    * submitReceive ({ payload }, { call, put }) {
      const res = yield call(service.submitReceive, payload)
      yield put({
        type: 'save',
        payload: {
          receiveData: res.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
